module.exports = __webpack_public_path__ + "static/media/SuperShuttle_web_1_preview.9b9ccd26.jpg";